import { AgendaPdf } from "./AgendaPdf";

export default AgendaPdf;
